module.exports = __webpack_public_path__ + "static/img/home6.f53d0bad.png";